import {Redirect, Route} from 'react-router-dom';
import {getLastValidStep, getPreviousStep, STATE_INCOMPLETE} from './steps';
import React from 'react';
import StepComponents from './containers/steps';

export default steps => {

    function createStepComponent(step) {
        const prevStep = getPreviousStep(steps, step);
        if (prevStep && prevStep.get('state') === STATE_INCOMPLETE) {
            const validStep = getLastValidStep(steps);
            return function () {  // eslint-disable-line
                return <Redirect to={validStep.get('route')}/>;
            };
        }

        return StepComponents[step.get('id')];
    }

    return (
        <div>
            {steps.map(step => {
                return React.createElement(
                    Route,
                    {
                        component: createStepComponent(step),
                        path: '/order/' + step.get('route').split('/').pop(),
                        key: step.get('id'),
                    }
                );
            }).toArray()}
        </div>
    );
};
